import { getOrderView } from "./orders.action";

export const APP_IS_OPEN_MENU = 'APP_IS_OPEN_MENU';
export const APP_IS_LOADER = 'APP_IS_LOADER';
export const APP_IS_OPEN_VIEW = 'APP_IS_OPEN_VIEW';

export const openView = (orderId) => (dispatch) => {
    dispatch(openLoader());
    dispatch(getOrderView(orderId));
    dispatch({ type: APP_IS_OPEN_VIEW, payload: true });
};

export const closeView = () => ({ type: APP_IS_OPEN_VIEW, payload: false });

export const openLoader = () => ({ type: APP_IS_LOADER, payload: true });

export const closeLoader = () => ({ type: APP_IS_LOADER, payload: false });

export const openMenuAction = () => ({ type: APP_IS_OPEN_MENU, payload: true });

export const closeMenuAction = () => ({ type: APP_IS_OPEN_MENU, payload: false });
